(function($){

	var homeHeroSlider = function() {
		$('.hero-slider').slick({
			arrows: true,
			prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.93 70"><polygon points="20.78 70 8.15 35.01 20.93 0 13.03 0 0 35 13.03 70 20.78 70"/></svg></button>',
			nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.93 70"><polygon points=".16 0 12.78 34.99 0 70 7.91 70 20.93 35 7.91 0 .16 0"/></svg></button>',
			dots: false,
			fade: false,
			speed: 2000,
			autoplay: true,
			autoplaySpeed: 4000,
			pauseOnHover: false
		});
	};

	var heroVideo = function() {

		$('[data-action="hero-popup-play"]').on('click', function(e) {
			e.preventDefault();

			var heroVideoModal = document.getElementById('hero-video-modal');
			var heroVideoModalObj = $('#hero-video-modal');

			$.magnificPopup.open({
				mainClass: 'hero-popup',
				items: {
					src: '#hero-video-modal-container',
					type: 'inline',
				},
				callbacks: {
					open: function() {
						if(heroVideoModalObj.length){
							heroVideoModal.play();
						}
					},
					close: function() {
						if(heroVideoModalObj.length){
							heroVideoModal.pause();
							heroVideoModal.currentTime = 0;
						}
					},
				}
			}, 0);
			
		});
		
		$('[data-action="hero-popup-embed"]').magnificPopup({
			type: 'iframe',
			// mainClass: 'hero-popup'
		});

	};


	var scrollAnim = function(){

		var win = $(window);

		var items = $('.scroll-animate-item');

		var itemScrollCheck = function(){

			var winHeight = win.innerHeight();
			var winTop = win.scrollTop();
			var scrollTriggerPos = (winHeight * .8) + winTop;

			items.each(function(i, el){

				var item = $(el);
				var itemTop = item.offset().top;

				if(itemTop <= scrollTriggerPos){
					item.addClass('vis');
				}
				else{
					item.removeClass('vis');
				}

			});

		};

		itemScrollCheck();
		optimizedScroll.add(itemScrollCheck);
	};


	var scrollToAnchor = function(){

		if( location.hash ){
			// window.scrollTo(0,0);

			$( 'body' ).removeClass( 'nav-open' );
			
			var locationHashObj = $(location.hash);
			
			if(locationHashObj.length > 0){
				//$('body').removeClass('nav-open');
				// $('body,html').animate({
				// 	scrollTop: locationHashObj.offset().top - 150
				// }, 500);

				var waitTime = 501;

				if(!$('body').hasClass('scrolled')){
					waitTime = 501;
					$('body').addClass('scrolled');
				}

				setTimeout(function(){
					var anchorPosition = locationHashObj.offset().top;
					var finalPosition = anchorPosition - $('.site-header').outerHeight() - 20;
					$("html, body").animate({scrollTop: finalPosition}, 1000);


				}, waitTime);
			}
		}

		$('.scroll-to-anchor a, a[href^="#"]').on('click', function(e){

			
			if($(this).hasClass('no-scroll')){
				return;
			}
			else if(this.hash){
				
				var hashTarget = $(this.hash);

				if( hashTarget.length ){
					e.preventDefault();
					var waitTime = 0;
					
					if(!$('body').hasClass('scrolled')){
						waitTime = 501;
						$('body').addClass('scrolled');
					}

					setTimeout(function(){
						var anchorPosition = hashTarget.offset().top;
						var finalPosition = anchorPosition - $('.site-header').outerHeight() - 20;
						$("html, body").animate({scrollTop: finalPosition}, 1000);

						$( 'body' ).removeClass( 'nav-open' );

					}, waitTime);
				}
			}
		});
	};

	var blockGallery = function() {
		$('.wp-block-gallery').magnificPopup({
			delegate: 'a',
			type: 'image',
			gallery: {
				enabled: true
			}
		})
	};

	var tileGallery = function() {
		if($("#tile-gallery").length){
			$("#tile-gallery").unitegallery({
				gallery_theme: "tiles",
				tiles_type: "nested",
				tiles_space_between_cols: 60,
				tiles_space_between_cols_mobile: 20,
				tiles_nested_optimal_tile_width: 250,
				tile_enable_shadow: false,
				// tile_enable_action: false
			});
		}
	};

	var caseSlider = function() {
		
		$('.msw-case-gallery-main-slider').slick({
			arrows: false,
			dots: false,
			speed: 1000,
			// autoplay: true,
			autoplaySpeed: 3000,
			pauseOnHover: false,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: true,
			asNavFor: '.msw-case-gallery-thumb-slider',
			adaptiveHeight: true
		});

		$('.msw-case-gallery-thumb-slider').slick({
			arrows: true,
			prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.93 70"><polygon points="20.78 70 8.15 35.01 20.93 0 13.03 0 0 35 13.03 70 20.78 70"/></svg></button>',
			nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.93 70"><polygon points=".16 0 12.78 34.99 0 70 7.91 70 20.93 35 7.91 0 .16 0"/></svg></button>',
			dots: false,
			speed: 1000,
			autoplay: true,
			autoplaySpeed: 3000,
			pauseOnHover: false,
			infinite: true,
			slidesToShow: 4,
			slidesToScroll: 1,
			asNavFor: '.msw-case-gallery-main-slider',
			responsive: [
			    {
			      breakpoint: 1024,
			      settings: {
			        slidesToShow: 3
			      }
			    }
			]
		});

		$(document).on('click', '[data-action="case-gallery-slidegoto"]', function() {
			var target = $(this).attr('data-target');
			$('.msw-case-gallery-thumb-slider').slick('slickGoTo', target);
		});
		
	};

	var homeServices = function() {
		$('[data-action="home-service"]').hover(
			function() {
				// var targetId = $(this).attr('data-target');

				// console.log(targetId);

				$('#' + $(this).attr('data-target')).addClass('vis');

			},
			function() {
				// var targetId = $(this).attr('data-target');
				$('#' + $(this).attr('data-target')).removeClass('vis');
			}
		);
	};

	var homeGallery = function() {
		$('[data-action="home-gallery-select-dropdown"]').on('click', function(e) {
			// e.preventDefault();
			$(this).toggleClass('vis');
		});

		$('[data-action="home-gallery-select"]').on('click', function(e) {
			e.preventDefault();

			var self = $(this);
			var targetId = self.attr('data-target');

			self.addClass('current');
			$('.gallery-select a').not(self).removeClass('current');

			$('#'+targetId).addClass('vis');
			$('.gallery').not('#'+targetId).removeClass('vis');
			
			$('.gallery-select').find('.title').text(self.text());
		});
	};


	$(document).ready(function(){
		homeHeroSlider();
		heroVideo();
		scrollAnim();
		scrollToAnchor();
		blockGallery();
		tileGallery();
		caseSlider();
		homeServices();
		homeGallery();
	});

    window.addEventListener('load', function() {
        var videoContainer = $('.hero-video-container');
        videoContainer.addClass('vis');
    }, false);

})(jQuery);


// jQuery(document).ready(function(){
	
// 	jQuery("#tile-gallery").unitegallery({
// 		gallery_theme: "tiles",
// 			tiles_type: "nested"						
// 	});
// });

/* Lazy load bg images https://web.dev/lazy-loading-images/ */
// document.addEventListener("DOMContentLoaded", function() {
//   var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-background"));

//   if ("IntersectionObserver" in window) {
//     let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
//       entries.forEach(function(entry) {
//         if (entry.isIntersecting) {
//           entry.target.classList.add("visible");
//           lazyBackgroundObserver.unobserve(entry.target);
//         }
//       });
//     });

//     lazyBackgrounds.forEach(function(lazyBackground) {
//       lazyBackgroundObserver.observe(lazyBackground);
//     });
//   }
// });